<template>
    <div>
        <v-autocomplete
            @update:search="userChange"
            @blur="$emit('blur')"
            :items="customers"
            :loading="inputLoading"
            v-model="localValue"
            hide-no-data
            :hide-selected="chips"
            :chips="chips"
            :closable-chips="chips"
            :multiple="multiple"
            :clearable="clearable"
            :error-messages="errorMessages"
            :rules="rules"
            ref="input"
            item-title="name"
            item-value="id"
            placeholder="حداقل 3 حرف جستجو کنید"
            label="مشتری"
            :value-comparator="(a, b) => a == b"
        ></v-autocomplete>
    </div>
</template>
<script>
export default {
    props: {
        modelValue: {
            required: true,
            default: null
        },
        chips: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        clearable: {
            type: Boolean,
            default: false
        },
        additionalFilters: {
            type: Object,
            default: null
        },
        errorMessages: {
            default: () => []
        },
        rules: {
            default: () => []
        },
    },
    data() {
        return {
            inputLoading: false,
            customers: [],
        }
    },
    computed: {
        localValue: {
            get: function () {return this.modelValue},
            set: function (value) {this.$emit('update:modelValue', value)}
        }
    },
    methods: {
        userChange(val) {
            if (!this.inputLoading && val && val.length > 2) {
                this.inputLoading = true;
                let params = {
                    employee: 0,
                    fast: 1,
                    keyword: val,
                };
                if (this.additionalFilters)
                    for(const key in this.additionalFilters)
                        if((Array.isArray(this.additionalFilters[key]) && this.additionalFilters[key].length) || (!Array.isArray(this.additionalFilters[key]) && this.additionalFilters[key]))
                            params[key] = this.additionalFilters[key];
                this.$userList(params).then((res) => {
                    if (res && res.status == "OK")
                        this.customers = [...this.customers.filter(x => this.multiple ? this.localValue.includes(x.id) : x.id == this.localValue), ...res.data]
                }).finally(() => this.inputLoading = false);
            }
        },
        checkList() {
            if (
                (Array.isArray(this.localValue) && this.localValue.length && this.localValue.some(x => !this.customers.some(y => y.id == x))) ||
                (!Array.isArray(this.localValue) && this.localValue && !this.customers.some(x => x.id == this.localValue))
            ){
                let params = {
                    employee: 0,
                    fast: 1,
                    ids: Array.isArray(this.localValue) ? this.localValue : [this.localValue],
                };
                this.$userList(params).then((res) => {
                    if (res && res.status == "OK")
                        this.customers = res.data;
                });
            }
        }
    },
    watch: {
        localValue() {
            this.checkList();
        }
    },
    mounted() {
        this.checkList();
    }
}
</script>
